module.exports = __webpack_public_path__ + "static/media/timer_pause.a8345355.svg";